export default "__VITE_ASSET__BuAl3qve__"